import { PropsWithChildren } from 'react'
import { css } from '@emotion/react'

import { useFlow } from 'utils/flow'

type StyledWrapProps = PropsWithChildren & {
  wrapCss?: string
  elementName: string
}

export default function StyledWrap({
  wrapCss,
  children,
  elementName,
}: StyledWrapProps): JSX.Element {
  const { data: flowData } = useFlow()
  const wrapperStyle = css`
    ${wrapCss ?? ''}${flowData?.theme?.stylings[elementName] ?? ''}
  `

  if (wrapperStyle.styles === '') {
    return <>{children}</>
  }

  return <div css={wrapperStyle}>{children}</div>
}
